const header = document.querySelector("header");

if (header) {
  const btn_hamburger = header.querySelector("svg.hamburger-menu");
  const mobile_menu = header.querySelector(".mobile-menu");

  //# Add hamburger button click events
  btn_hamburger.onclick = () => {
    btn_hamburger.classList.toggle("active");
    mobile_menu.classList.toggle("active");
    document.documentElement.classList.toggle("no-scroll");
  };


  //# Add custom class to anchor links that match the active page
  const active_page = header.dataset.currentPage;

  //% Get all header links that match the active page in their href
  const activePageLinks = header.querySelectorAll(`a[href*="${active_page}"]`);

  //% Add custom class to all active page links in header
  activePageLinks.forEach((link) => {

    //$ This if avoids adding the current-page class to the contact CTA button on desktop view
    if ( !link.classList.contains('btn')) {
      link.classList.add("current-page");
    } 
    
  });
}
